import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import RecordType from './Record/RecordType';

//TODO-RecordType이 rsuite에 엄청난 의존성을 가지고 있음 원인은 모름
const LazyComponent = (component) => {
  return (
    <Suspense fallback={null}>
      {React.createElement(component)}
    </Suspense>
  );
};

const routes = [
  { path: "/", component: lazy(() => import('./Pages/Login')) },
  { path: "/site", component: lazy(() => import('./Pages/Site')) },
  { path: "/dashboard", component: lazy(() => import('./Pages/Dashboard')) },
  {
    path: "/apps", component: lazy(() => import('./Components/NavBar')), subRoutes: [
      { path: "chart", component: lazy(() => import('./Pages/Chart')) },
      { path: "hvac", component: lazy(() => import('./Pages/HVAC')) },
      { path: "uc", component: lazy(() => import('./Pages/UC')) },
      { path: "nutrient", component: lazy(() => import('./Pages/Nutrient')) },
      { path: "lighting", component: lazy(() => import('./Pages/Lighting')) },
      { path: "envSubmit", component: lazy(() => import('./Pages/EnvSubmit')) },
      {
        path: "record", component: lazy(() => import('./Pages/Record')), subRoutes: [
          { path: "edit", component: RecordType }
        ]
      }
    ]
  },
  { path: "/apps/liveenv", component: lazy(() => import('./Pages/LiveEnv')) },
  { path: "/apps/livecontrol", component: lazy(() => import('./Pages/LiveMoniter')) },
  { path: "*", component: lazy(() => import('./Pages/NotFound')) },
];

function App() {
  return (
    <Routes>
      {routes.map((route, index) => (
        <Route
          key={index}
          path={route.path}
          element={LazyComponent(route.component)}
        >
          {route.subRoutes && route.subRoutes.map((subRoute, subIndex) => (
            <Route key={subIndex} path={subRoute.path} element={LazyComponent(subRoute.component)} />
          ))}
        </Route>
      ))}
    </Routes>
  );
}

export default App;
